import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import initializeRum from './customerMonitoringTelemetry/cwrumconfig';

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
window.addEventListener('load', async () => {
  await initializeRum();
});
